
import Vue from "vue";

export default Vue.extend({
    name: "ScrollablePane",
    data: () => ({}),
    props: {
        height: {
            type: String,
            required: false,
        },
    },
    computed: {
        style() {
            let style = "";
            if (this.height != null) {
                style += `height: ${this.height}; `;
            }
            return style;
        },
    },
});
